import React, { Component } from 'react'
import { Table, Row, Col, Button, Icon, Input, Spin } from 'antd';
import { CSVLink  } from 'react-csv';
import _ from 'underscore';

export default class EmployeeData extends Component {

    constructor( props ){
        super( props );

        this.state = {
            data: [],
            download_csv: [],
            company_filter: [{ text: 'None', value: 'None' }],
            department_filter: [{ text: 'None', value: 'None' }],
            designation_filter: [{ text: 'None', value: 'None' }],
            loading: false
        }

        this.convert_to_csv = this.convert_to_csv.bind( this );
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => 
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                } 
            }
            
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.length !== 0 ){
            this.setState({
                loading: false
            });
        }

        let temp_designation_filter = [];
        let temp_department_filter = [];
        
        nextProps.onData.map( (item, i ) => {
            temp_designation_filter.push( { text: item.designation_name, value: item.designation_name } )
            temp_department_filter.push({ text: item.department_name, value: item.department_name } )
        });

        let temp_desg = this.getUniqueListBy( temp_designation_filter, 'text' );
        let temp_dep = this.getUniqueListBy( temp_department_filter, 'text' );

    
        this.setState({ 
            data: nextProps.onData,
            designation_filter: temp_desg,
            department_filter: temp_dep
        });

        this.convert_to_csv( nextProps.onData );

        this.setState({
            company_filter: nextProps.onCompany
        });

    }

    componentWillMount(){

        // console.log( 'ss' )

        this.setState({
            loading: true
        })

    }

    getUniqueListBy(arr, key) {
        return [...new Map(arr.map(item => [item[key], item])).values()]
    }

    convert_to_csv( data ){

        let temp_data = [];

        data.map( (item, k ) => {

            let stack = {
                "full_name": item.full_name,
                'company_name': item.company_name,
                'designation_name': item.designation_name,
                'department_name': item.department_name,
                'date_of_joining': item.date_of_joining,
                'sponsorship': item.sponsorship,
                'passport_expiry': item.passport_expiry,
                'visa_expiry_date': item.visa_expiry_date,
                'emirates_expiry': item.emirates_expiry,
                'tecom_expiry': item.tecom_expiry,
                'insurance_expiry': item.insurance_expiry,
                'other_email': item.other_email,
                'birth_date': item.birth_date,
                'gender': item.gender,
                'marital_status': item.marital_status,
                'religion': item.religion,
                'employee_status': item.employee_status
            }

            temp_data.push( stack );

        });

        this.setState({ download_csv: temp_data });

    }

    render() {

        const headers = [
            {label: "Employee Name",  key: "full_name"},
            {label: "DV Team",  key: "company_name"},
            {label: "Designation",  key: "designation_name"},
            {label: "Department",  key: "department_name"},
            {label: "Date of Joining",  key: "date_of_joining"},
            {label: "Visa Sponsorship",  key: "sponsorship"},
            {label: "Passport Expiry",  key: "passport_expiry"},
            {label: "Residence Visa Expiry",  key: "visa_expiry_date"},
            {label: "Emirates ID Expiry",  key: "emirates_expiry"},
            {label: "Tecom Labor Card Expiry",  key: "tecom_expiry"},
            {label: "Medical Insurance Expiry",  key: "insurance_expiry"},
            {label: "Personal Email",  key: "other_email"},
            {label: "Date of Birth",  key: "birth_date"},
            {label: "Gender",  key: "gender"},
            {label: "Marital Status",  key: "marital_status"},
            {label: "Religion",  key: "religion"},
            {label: "Employee Status",  key: "employee_status"},
        ];

        const columns = [
            {
                title: 'Employee Name',
                dataIndex: 'full_name',
                key: 'full_name',
                ...this.getColumnSearchProps( 'full_name' )
            },
            {
                title: 'DV Team',
                dataIndex: 'company_name',
                key: 'company_name',
                filters: this.state.company_filter,
                onFilter: ( value, record ) => record.company_name.indexOf(value) === 0,
            },
            {
                title: 'Designation',
                dataIndex: 'designation_name',
                key: 'designation_name',
                filters: this.state.designation_filter,
                onFilter: ( value, record ) => record.designation_name.indexOf(value) === 0,
            },
            {
                title: 'Department',
                dataIndex: 'department_name',
                key: 'department_name',
                filters: this.state.department_filter,
                onFilter: ( value, record ) => record.department_name.indexOf(value) === 0,
            },
            {
                title: 'Date of Joining',
                dataIndex: 'date_of_joining',
                key: 'date_of_joining',
            },
            {
                title: 'Visa Sponsorship',
                dataIndex: 'sponsorship',
                key: 'sponsorship',
            },
            {
                title: 'Passport Expiry',
                dataIndex: 'passport_expiry',
                key: 'passport_expiry',
            },
            {
                title: 'Residence Visa Expiry',
                dataIndex: 'visa_expiry_date',
                key: 'visa_expiry_date',
            },
            {
                title: 'Emirates ID Expiry',
                dataIndex: 'emirates_expiry',
                key: 'emirates_expiry',
            },
            {
                title: 'Tecom Labor Card Expiry',
                dataIndex: 'tecom_expiry',
                key: 'tecom_expiry',
            },
            {
                title: 'Medical Insurance Expiry',
                dataIndex: 'insurance_expiry',
                key: 'insurance_expiry',
            },
            {
                title: 'Personal Email',
                dataIndex: 'other_email',
                key: 'other_email',
            },
            {
                title: 'Date of Birth',
                dataIndex: 'birth_date',
                key: 'birth_date',
            },
            {
                title: 'Gender',
                dataIndex: 'gender',
                key: 'gender',
            },
            {
                title: 'Marital Status',
                dataIndex: 'marital_status',
                key: 'marital_status',
            },
            {
                title: 'Religion',
                dataIndex: 'religion',
                key: 'religion',
            },
            {
                title: 'Employee Status',
                dataIndex: 'employee_status',
                key: 'employee_status',
                filters: [
                    { text: 'Active', value: 'Active' },
                    { text: 'Terminated', value: 'Terminated' },
                    { text: 'Deceased', value: 'Deceased' },
                    { text: 'Resigned', value: 'Resigned' }
                ],
                onFilter: ( value, record ) => record.employee_status.indexOf(value) === 0,
            }
        ];

        
        return (
            <div>
                <Spin spinning={this.state.loading}>
                <Row>
                    <Col span={24} style={{ paddingBottom: '17px' }}>
                        <CSVLink 
                            headers={headers}
                            filename={"Employee-Data-Information.csv"}
                            data={ this.state.download_csv } target="_blank" >
                            <Button className="fl_right clearfix" type="default">Download CSV</Button></CSVLink >                    
                    </Col>
                </Row>

                <Table columns={ columns } dataSource={ this.state.data } scroll={{ x: 3000 }} />
                </Spin>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/reports/childs/employee_data.js